import { Menu } from 'react-admin';
import SubMenu from './SubMenu';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';

export const CustomMenu = () => (
  <Menu>
    <Menu.DashboardItem />
    <Menu.ResourceItem name="entities" />

    <SubMenu primaryText="Game Configs" leftIcon={<SportsEsportsIcon />}>
      <Menu.ResourceItem name="game-configs" />
      <Menu.ResourceItem name="connections-creator" />
      <Menu.ResourceItem name="timeline-creator" />
      <Menu.ResourceItem name="grid-2d-config" />
      <Menu.ResourceItem name="grid-3d-config" />
      <Menu.ResourceItem name="intersection-tester" />
      <Menu.ResourceItem name="trivia-game-creator" />
    </SubMenu>

    <Menu.ResourceItem name="admin-users" />
    <Menu.ResourceItem name="verification" />
    <Menu.ResourceItem name="audit-logs" />
    <Menu.ResourceItem name="bulk-operations" />
    <Menu.ResourceItem name="scraper-jobs" />
    <Menu.ResourceItem name="trivia-upload" />
    <Menu.ResourceItem name="duplicates" />
  </Menu>
);
